import styled from "styled-components";
export const HeaderForm = styled.div`
  width: 70%;
  margin: auto;
  h2 {
    font-size: 2.7rem;
    font-weight: bold;
    background: var(--main-color);
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
  }
  > p {
    padding: 0 0 2rem 0;
    font-size: 1rem;
    color: var(--gray);
  }
`;
